import ForgotPassword from "../features/Auth/Components/ForgotPassword";

function ForgotPasswordPage() {
    return(
        <div>
            <ForgotPassword/>
            </div>
    )
}
export default ForgotPasswordPage;